// © Microsoft Corporation. All rights reserved.

import { Telemetry, TelemetryAttrName, TelemetryObjectBase } from "@msnews/telemetry-contracts";

import React from "react";

/**
 * Returns an HOC for tracking telemetry of a React.Component.
 * @param WrappedComponent - the component to track telemetry.
 * @param telemetryObject - the telemetry object of the component.
 */
export function trackComponent<TProps, TState>(
    WrappedComponent: React.ComponentType<TProps>,
    telemetryObject: TelemetryObjectBase
): React.ComponentClass<TProps> {

    return class ComponentTracker extends React.Component<TProps, TState, never> {
        /** Telemetry object for the component. */
        private telemetryObject: TelemetryObjectBase;

        constructor(props: TProps, context?: any) {
            super(props, context);
            this.telemetryObject = telemetryObject;
        }

        /** React render lifecycle handler  */
        public render(): JSX.Element {
            return <WrappedComponent {...this.props} {...this.telemetryObject.render()} />;
        }
    };
}